/*
 * Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { SubscriptionPolicies } from "../../data/interfaces";
import {
  SubscriptionPoliciesActions,
  FETCH_SUBSCRIPTION_POLICIES_FOR_ORGANIZATION_REQUEST,
  FETCH_SUBSCRIPTION_POLICIES_FOR_ORGANIZATION_SUCCESS,
  FETCH_SUBSCRIPTION_POLICIES_FOR_ORGANIZATION_FAILURE,
} from "../types/subscriptionPolicies";

const initialState: SubscriptionPolicies = {
  subscriptionPolicies: {
    list: [],
    count: 0,
    pagination: { next: "", offset: 0, total: 0, limit: 0, previous: "" },
  },
  error: "",
  loading: false,
  success: false,
};

const subscriptionPoliciesReducer = (
  state = initialState,
  action: SubscriptionPoliciesActions
) => {
  switch (action.type) {
    case FETCH_SUBSCRIPTION_POLICIES_FOR_ORGANIZATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
        success: false,
      };
    case FETCH_SUBSCRIPTION_POLICIES_FOR_ORGANIZATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        subscriptionPolicies: action.payload
          ? action.payload
          : { subscriptionPolicies: [] },
        error: "",
        success: true,
      };
    }
    case FETCH_SUBSCRIPTION_POLICIES_FOR_ORGANIZATION_FAILURE: {
      return {
        ...state,
        loading: false,
        subscriptionPolicies: {},
        error: action.payload,
        success: false,
      };
    }
    default:
      return state;
  }
};

export default subscriptionPoliciesReducer;
